module.exports = __webpack_public_path__ + "static/media/alert_24x24.670ce617.ico";